"use client";

import React from 'react';

const SkipLink: React.FC = () => {
  const handleSkipToContent = () => {
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <a
      href="#main-content"
      onClick={handleSkipToContent}
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[10000] bg-accent text-background px-4 py-2 rounded-md font-medium transition-all duration-200"
    >
      Skip to main content
    </a>
  );
};

export default SkipLink;